<template>
  <div class="row items-center gordita-400-12 ib-color-red text-center">
    <span class="icon-Approval-error"><span class="path1"></span><span class="path2"></span></span>
    <div class="message-text">{{ errorMessage }}</div>
  </div>
</template>

<script>
export default {
  name: 'InputErrorMessage',
  props: {
    errorMessage: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.message-text {
  padding-left: 5px;
}
</style>
